import KatexViewer from '@/helpers/Katex';
import React, { useEffect, useState } from 'react';

const TestInputRadio = ({ option, onAnswered, question, a }) => {
  const [checked, setChecked] = useState(false);
  const [radioId, setRadioId] = useState<any>('');
  useEffect(() => {
    setChecked(false);
    return () => {
      setChecked(false);
    };
  }, []);
  const handleClick = () => {
    onAnswered('q-' + question.q_no, option, a.id);
    setChecked(true);
    let radioID: any = document.getElementById(`radio-${a.id}`);
    setRadioId(radioID ? radioID : '');
    radioID.checked = true;
  };

  return (
    <li
      className="cursor-pointer"
      onClick={() => handleClick()}
      style={{
        border: radioId?.checked ? '2px solid #283360' : '1px solid #e2e2e2',
      }}
    >
      <span className="lq-number cursor-pointer">{option}</span>
      <span className="my-radio">
        <input
          type="radio"
          id={`radio-${a.id}`}
          className="me-1 my-auto"
          name={'q-' + question.q_no}
          value={option}
          // checked={checked}
        />
        <label className="ml-1 my-auto">
          {question?.has_expression ? <KatexViewer text={a?.text} /> : a.text}
        </label>
      </span>
    </li>
  );
};
export default TestInputRadio;
